define('lq/events/actions/desktopClientCommand',[
    'underscore',
    'lq/events/actions/eventAction'
], function (_, EventAction) {
    'use strict';

    function DesktopClientCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        this.eventData = eventData;
        return this;
    }

    EventAction.extend(DesktopClientCommand, EventAction);

    DesktopClientCommand.typeName = 'DesktopClientCommand';

    DesktopClientCommand.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    DesktopClientCommand.prototype.createEventActionRequest = function () {
        return {
            eventActionType: "PrepareDesktopClientCommand",
            commandId: this.eventData.command
        };
    };

    DesktopClientCommand.prototype.execute = function (continuation, eventActionResponse) {
        window.location.href = eventActionResponse.url;
        continuation();
    };
    
    return DesktopClientCommand;
});
